import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto flex flex-col items-center">
            <img
              src="/core-logo.svg"
              alt="CORE Logo"
              className="h-48 w-48"
            />
            <h2 className="mt-2 text-center text-3xl font-extrabold text-gray-900">
              HR Query App
            </h2>
            <p className="mt-2 text-center text-lg text-gray-600">
              Core Natural Resources
            </p>
            <p className="mt-5 text-center text-sm text-gray-600">
              Sign in to your account below.
            </p>

            <button
              className="group relative w-full flex justify-center mt-10 py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleSubmit}
            >
              <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
              Log in with Okta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 